import { Provider } from 'react-redux';
import { i18nReducer, loadTranslations, setLocale, syncTranslationWithStore } from 'react-redux-i18n';
import { combineReducers } from 'redux';

import { createStore, createReducer } from '@common/utils/redux';
import { setAppConfig } from "@common/utils/config";

import { inviteStatusEN } from './translations/en';
import { inviteStatusES } from './translations/es';
import { inviteStatusJA } from './translations/ja';
import { InviteStatus } from './invite-status';
import { mountReactNode } from '@common/utils/react';

export const initInviteStatus = (
  componentId,
  locale,
  liveSearchEnabled = true,
  liveSearchDelay = 300,
) => {
  try {
    const store = createStore(combineReducers({ i18n: i18nReducer }));
    syncTranslationWithStore(store);

    setAppConfig({
      inviteStatus: {
        liveSearchEnabled,
        liveSearchDelay,
      }
    });
  
    const translation = {
      en: inviteStatusEN,
      ja: inviteStatusJA,
      es: inviteStatusES,
    };
  
    if (!translation[locale]) {
      locale = 'en';
    }
  
    store.dispatch(loadTranslations(translation));
    store.dispatch(setLocale(locale));
  
    mountReactNode(
      <Provider store={store}>
        <InviteStatus />
      </Provider>,
      document.getElementById(componentId)
    );
  } catch(err) {
    throw err;
  }
};